import request from '@/utils/request'

export const captchaImage = '/captchaImage2'

export function registerUser(data) {
  return request({
    url: '/register',
    method: 'POST',
    data
  })
}

export function login(data) {
  return request({
    url: '/login',
    method: 'POST',
    data
  })
}
